import { createFeatureSelector } from '../../../../helpers/createFeatureSelector';
import { IHrState, HR_STORE_KEY } from '../reducers';

export const selectHrModuleState = createFeatureSelector<IHrState>(HR_STORE_KEY);
